
const digest = '4d1c1515ea5118b9a39ddaed90dac6eb3917d385fb3c0697174a04c9e38948ef';
const classes = {"wrapper":"_wrapper_905zo_1","controls":"_controls_905zo_7","list":"_list_905zo_16"};
const css = `._wrapper_905zo_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  height: 100%;
}
._wrapper_905zo_1 ._controls_905zo_7 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #ffffff;
  border: 1px solid #eaedf4;
  padding: 8px 12px;
  gap: 20px;
}
._wrapper_905zo_1 ._list_905zo_16 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  border: 1px solid #eaedf4;
  border-top: 0;
}
._wrapper_905zo_1 ._list_905zo_16::-webkit-scrollbar {
  display: block;
}
._wrapper_905zo_1 ._list_905zo_16::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_905zo_1 ._list_905zo_16::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_905zo_1 ._list_905zo_16::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_905zo_1 ._list_905zo_16::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  